import dimensionEnum from "@/model/dimensionEnum";
import { calculatedColumnsEnum } from "@/model/columnsEnums";
import moment from "moment";
import mesureEnum from "@/model/mesureEnum";

function dateFormat(date, key = "") {
  var s = date;
  var format = "";
  try {
    switch (key) {
      case dimensionEnum.TIME:
        format = dateFormatEnum.TIME_FORMAT;
        break;
      case dimensionEnum.DATE:
        format = dateFormatEnum.DATE_LONG_FORMAT;
        break;
      case dimensionEnum.OMNIPLAYEVENT_EVENTBUSINESSDATE:
      case dimensionEnum.OMNIPLAYEVENT_ORDERBUSINESSDATE:
        format = dateFormatEnum.DATE_SHORT_FORMAT_YY;
        break;
      case "datePickerPeriod":
        format = dateFormatEnum.DATEPERIOD_LONG_FORMAT;
        break;
      case "dateFilter":
        format = dateFormatEnum.SQL_DATE_FORMAT;
        break;
      case "datePickerPeriodShort":
        format = dateFormatEnum.DATE_SHORT_FORMAT;
        break;
      case "datePickerPeriodMedium":
        format = dateFormatEnum.DATEPERIOD_MEDIUM_FORMAT;
        break;
      case calculatedColumnsEnum.DATE:
        format = dateFormatEnum.DATE_DAY_FORMAT;
        break;
      case mesureEnum.VSMARTTOUCHMAINTENANCE_LAST_EVENT_DATE:
      case dimensionEnum.SMARTTOUCHMAINTENANCE_END_OF_MAINTENANCE:
      case mesureEnum.VSMARTTOUCHMAINTENANCE_LAST_END_OF_MAINTENANCE:
        format = dateFormatEnum.MOMENT_DATETIME_FORMAT
        break;
      case dimensionEnum.STAFFGAMEHISTORY_EVENTDATE:
        format = dateFormatEnum.DATEPERIOD_FORMAT;
        break;
    }
    s = moment(date).format(format);
  } catch (error) {
    console.log(error);
  }
  return s;
}

const dateFormatEnum = {
  TIME_FORMAT: "HH:mm",
  DATE_LONG_FORMAT: "D MMMM YYYY",
  DATE_DAY_FORMAT: "ddd D MMM",
  DATE_SHORT_FORMAT: "DD/MM/YYYY",
  DATE_SHORT_FORMAT_YY: "DD/MM/YY",
  DATE_FORMAT_FOR_FILENAME: "DD-MM-YYYY",
  DATEPERIOD_FORMAT: 'DD/MM/YYYY HH:mm',
  DATEPERIOD_MEDIUM_FORMAT: "dddd DD/MM/YYYY",
  DATEPERIOD_LONG_FORMAT: "dddd DD/MM/YYYY - H[h]",
  /** Format de date reconnu par moment.js donc par les helpers valueFormatter / dateformat */
  MOMENT_DATE_FORMAT: "YYYY-MM-DD",
  /** Format de date et heure reconnu par moment.js donc par les helpers valueFormatter / dateformat */
  MOMENT_DATETIME_FORMAT: "YYYY-MM-DD HH:mm",
  /** Format de date SQL sans heure */
  SQL_DATE_FORMAT: "YYYY-MM-DD",
  PERIOD_DATE_WITH_YEAR_FORMAT: "DD MMM YYYY",
  PERIOD_DATE_WITHOUT_YEAR_FORMAT: "DD MMM",
}

export { dateFormat }
export { dateFormatEnum }